export default __webpack_public_path__ + "static/media/login.a2e0f931.svg";